<div #googleButtonDiv></div>

@if (showMicrosoft) {
  <button
    type="button"
    class="microsoft-button"
    data-testid="microsoft-login-btn"
    [disabled]="microsoftPending()"
    (click)="signInWithMicrosoft()">
    <!-- Inline so the logo needs no asset pipeline and no extra network origin. -->
    <svg class="microsoft-button-logo" viewBox="0 0 21 21" aria-hidden="true" focusable="false">
      <rect x="0" y="0" width="10" height="10" fill="#f25022" />
      <rect x="11" y="0" width="10" height="10" fill="#7fba00" />
      <rect x="0" y="11" width="10" height="10" fill="#00a4ef" />
      <rect x="11" y="11" width="10" height="10" fill="#ffb900" />
    </svg>
    <span class="microsoft-button-label">{{ 'LOGIN.MICROSOFT' | transloco }}</span>
  </button>
}
